<template>
  <b-modal class="text-right" size="lg" :id="`modal-${product.id}`" hide-footer>


    <b-row>
      <b-col lg="6" class="product-gallery">
        <swiper id="products-300-categories-slider" class="w-100" ref="mySwiper"
                :options="swiperOptions">

          <swiper-slide v-for="image in productImages" :key="image.id">
            <img :src="image.file" :alt="product.name" class=" img-slider">
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </b-col>
      <b-col lg="6">
        <div class="text-right">
          <b-col>
            <b-row class="p-0 m-0">
              <b-col cols="10">
                <h5 class="my-4 ">{{ product.name }}</h5>
              </b-col>
              <b-col cols="2" class="p-0 rating-section mt-4 " v-if="product.rate_count > 0">
                <span class="d-inline text-right"><b-icon-star-fill
                    class="rate"/> ({{ product.rate_count }}) {{ product.rate }}</span>
              </b-col>
            </b-row>
          </b-col>

          <b-row class="mx-auto">
            <b-col cols="6">
              <m-product-price-100 class="text-white text-center mx-auto" :product="product"/>
            </b-col>
            <b-col cols="6">
              <m-shopping-cart-controller-1 class="pb-3 mx-auto" :product="product"/>
            </b-col>
          </b-row>


        </div>
      </b-col>
    </b-row>

    <b-col lg="12" class="text-right">
      <div v-b-toggle="`product-description-${product.id}`">
        <p v-html="contentSlicer(processContent(product.description != null ? product.description : '' ),150)"
           class="my-4"/>
      </div>


      <b-collapse :id="`product-description-${product.id}`" class="mt-2"
                  v-html="processContent(product.description != null ? product.description : '')"></b-collapse>


      <m-comments-form-1 :commentable_id="product.id" commentable_type="product"/>

      <div class="mt-5 ">
        <h3 class="text-center">نظرات</h3>
        <m-comments-wrapper commentType="product" :item_id="product.id">
          <b-row slot-scope="{comments}">
            <div class="col-lg-12" v-if="comments.length">
              <b-col lg="12" class="border border-1 rounded rounded-9 p-3" v-for="comment in comments"
                     :key="comment.id">
                <b-row>
                  <b-col lg="6">
                    <span class="font-smaller">{{ formatDate(comment.created_at) }}</span>
                    <p class="font-weight-bolder">{{ comment.user.name }} {{ comment.user.last_name }} <span
                        v-if="comment.commentable_type == 'order'">(خریدار)</span></p>
                  </b-col>
                  <b-col lg="6">
                    <div class="float-left">
                      <b-icon-star-fill class="rate"/>
                      <span class="font-weight-bolder mr-1">{{ comment.rate }}</span>
                    </div>
                  </b-col>


                  <b-col lg="12" v-if="comment.commentable_type == 'order'">
                    <span class="mx-4 badge badge-light"
                          v-for="product in comment.commentable.products">{{ product.name }}
                    <span v-for="category in product.category">({{ category.name }})</span>
                    </span>
                  </b-col>

                  <b-col lg="12">{{ comment.body }}</b-col>
                </b-row>
              </b-col>
            </div>
            <div class="col-lg-12" v-else>
              <b-col lg="12" class="text-center">
                <p class="text-center"> نظری ثبت نشده است.</p>
              </b-col>
            </div>
          </b-row>
        </m-comments-wrapper>
      </div>

    </b-col>


  </b-modal>
</template>

<script>
import {dateConverter} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter'
import {directive, Swiper, SwiperSlide} from "vue-awesome-swiper";
import "swiper/css/swiper.css";


export default {
  name: "Product300Modal",
  components: {Swiper, SwiperSlide, directive,},
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true,
        },

      },
    }
  },
  props: {
    product: {}
  },
  computed: {
    productImages() {
      let images = this.product.images;
      images.push({file: this.product.thumbnail}) // add thumbnail to images
      return images
    }
  },
  methods: {
    formatDate(date) {
      return dateConverter(date, '/', true)
    }
  }
}
</script>

<style>
.product-gallery .swiper-slide {
  background-size: cover;
  background-position: center;
  background: white;
}

.product-gallery .gallery-top {
  height: 250px !important;
  width: 100%;
}

.product-gallery .swiper-slide {
  width: 100%;
  height: 250px;
}

.product-gallery .swiper-slide-active {
  opacity: 1;
}

.product-gallery .img-slider{
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.rate {
  color: #ffce00;
  fill: #ffce00;
}

.rating-section {
  font-size: 14px;
  font-weight: bolder;
}
</style>